import $ from 'jquery';

export function generalScripts() {
    $(document).on('click', '.trigger-account-popup', function () {
        if (window.innerWidth < 811) {
            const targetLink = $(document).find(`.NavigationTabs-account`);
            if (targetLink.length > 0) {
                targetLink.trigger('click');
            }
        } else {
            const targetLink = $(document).find(`.Header-MyAccountWrapper`);
            if (targetLink.length > 0) {
                targetLink.trigger('click');
            }
        }
    });
    $(document).on('click', '.js-anchor', function (e) {
        e.preventDefault();

        const target = $($(this).data('href').replace(/\//g, ''));

        if (target.length > 0) {
            $('body, html').stop().animate({
                scrollTop: target.offset().top - 90 - 85,
            }, 1000, 'swing');
        }
    });
    $(document).ready(() => {
        function switchTab(tabId) {
            $('.MultiTabWidget-Tab').removeClass('active');
            $('.MultiTabWidget-Slider').removeClass('active');

            $(`[data-tab="${tabId}"]`).addClass('active');
            $(`#${tabId}`).addClass('active');
        }

        $(document).on('click', '.MultiTabWidget-Tab', function () {
            const tabId = $(this).data('tab');
            switchTab(tabId);
        });
    });
    // FindbarEvent tests
    // $(document).on('click', '.AddToCart', function () {
    //     window.dispatchEvent(new CustomEvent("AddToCart", {
    //         detail: {
    //             title: "Perfect Cleansing Oil",
    //             id: 87375,
    //             isAddtoCart: true,
    //             isMultiTab: false,
    //             sku: "00001231650",
    //         }
    //     }));
    // })
    // $(document).on('click', '.ProductWishlistButton-Button', function () {
    //     window.dispatchEvent(new CustomEvent("ProductWishlist", {
    //         detail: {
    //             extra: {
    //                 title: "Perfect Cleansing Oil",
    //                 id: 87375,
    //                 isAddtoCart: false,
    //                 isMultiTab: false,
    //                 sku: "00001231650",
    //             },
    //             isSimple: true,
    //             isWishlistItem: true
    //         }
    //     }));
    // })
}
